import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

/**
 * Holds the dialog at roughly the height of a short results table while the request settles, and again
 * if it settles with nothing to show, so neither outcome is a thin strip the table would shove around.
 */
export const RideMeasuredTimesStatusStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-measured-times-status",
  },
)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;

  & .ride-measured-times__message {
    margin: 0;
    max-width: 480px;
    text-align: center;
    font-size: 1rem;
    line-height: 1.5;
    color: ${greyMui._700};
  }
`;
